import React, { type Dispatch, type SetStateAction } from 'react';
import { useTranslation } from 'react-i18next';

import { date, getVendorDataColumn, status, type } from 'components/data/inspections';
import { Button } from 'components/ui';
import { type AtlasGqlInspection } from 'types/atlas-graphql';
import { useAccountContext } from 'utils/account/AccountContext';
import { STANDARD_COLUMN_SCROLL_Y } from 'utils/constants';
import { INSPECTION_VENDOR_NAMES } from 'utils/release-toggles';

import { Steps } from '../UploadInspectionDataModal';
import { ButtonContainer, ValidationTable } from '../UploadInspectionDataModal.style';

export type ValidationProps = {
  inspection: AtlasGqlInspection;
  hasNewInspectionTask: boolean;
  setStep: Dispatch<SetStateAction<Steps>>;
  rollback: {
    update: (toastMessage?: string) => Promise<void>;
    loading: boolean;
  };
};

export const Validation: React.FC<ValidationProps> = ({ inspection, setStep, rollback }) => {
  const { t } = useTranslation();
  const { hasReleaseToggle } = useAccountContext();
  const { update: _handleRollback, loading: rollbackLoading } = rollback;

  const handleContinue = () => {
    const nextStep = Steps.DetailsUpload;
    setStep(nextStep);
  };

  const handleRollback = async () => {
    await _handleRollback();

    setStep(Steps.SingleUpload);
  };

  return (
    <>
      <p>{t('inspection.inspectionSuccessfullyCreated', 'Inspection successfully created.')}</p>
      <ValidationTable
        columns={[
          date,
          type,
          getVendorDataColumn(hasReleaseToggle(INSPECTION_VENDOR_NAMES)),
          status,
        ]}
        dataSource={[inspection]}
        scroll={STANDARD_COLUMN_SCROLL_Y}
      />
      <ButtonContainer>
        <Button type="primary" danger={true} onClick={handleRollback} loading={rollbackLoading}>
          {t('inspection.rollBackChanges', 'Roll Back Changes')}
        </Button>
        <Button type="primary" onClick={handleContinue}>
          {t('inspection.continueToDetails', 'Continue to Details')}
        </Button>
      </ButtonContainer>
    </>
  );
};
